<div class="flex w-full flex-col gap-4">
  <div class="flex w-full items-start gap-4">
    <div class="w-full min-w-0 flex-1">
      <header class="mb-5 flex items-center justify-between gap-4">
        <h1 class="m-0 font-heading text-2xl font-bold tracking-tight text-fg">{{ title }}</h1>
        @if (roleAccess.isActiveSystemRole()) {
          <a uiButton [routerLink]="shellRoutes.commands('manage', entityKey, 'new')">New batch</a>
        }
      </header>
      <lib-dynamic-list [listPath]="listPath" (rowSelect)="onRowSelect($event)" />
    </div>
  </div>
</div>
